import React from 'react';
import { H4 } from './headline4-styled-component';

const Headline4 = props => {
  return <H4>{props.children}</H4>;
};

export default Headline4;
